<template>
  <div class="overflow-x-hidden">
    <div class="bg-black">
      <TheHero />
    </div>
    <div class="bg-black px-5 md:px-24">
      <div id="new" class="pt-24">
        <ScrollingTag />
      </div>
      <AboutSection class="py-28" id="about" />
      <TheSeperator class="-ml-5 md:-ml-24" />
      <TheGallery class="-ml-5 md:-ml-24" />
      <img
        src="./assets/imgs/icon-issue-1-white.svg"
        class="-mb-36 mt-36 md:-mb-56 md:mt-56 w-24 -rotate-12"
      />
      <ScrollingTag :shouldBeRotated="true" />
    </div>
    <MagazinePreview />
    <div class="bg-grey px-5 md:px-24">
      <TheSeperator class="-ml-5 md:-ml-24" :isBlack="true" />
      <AboutBlackout />
      <BackToTop class="mt-16 md:mt-24" />
    </div>
    <TheContact class="pt-24 md:pt-48" id="contact" />
    <TheFooter class="px-5 md:px-24" />
  </div>
</template>

<script setup>
import "./assets/tailwind.css";
import TheHero from "./components/TheHero.vue";
import ScrollingTag from "./components/ScrollingTag.vue";
import AboutSection from "./components/AboutSection.vue";
import TheSeperator from "./components/TheSeperator.vue";
import TheGallery from "./components/TheGallery.vue";
import MagazinePreview from "./components/MagazinePreview.vue";
import AboutBlackout from "./components/AboutBlackout.vue";
import BackToTop from "./components/BackToTop.vue";
import TheContact from "./components/TheContact.vue";
import TheFooter from "./components/TheFooter.vue";
import { onMounted } from "vue";


onMounted(() => {
  window.scrollTo(0,0)
})
</script>
